const router = [
  {
    path: '/information-home',
    name: 'InformationHome',
    component: () => import('../views/Information/InformationHome.vue')
  },
  {
    path: '/notice-home',
    name: 'NoticeHome',
    component: () => import('../views/Information/NoticeHome.vue')
  },
  {
    path: '/notice-detail',
    name: 'NoticeDetail',
    component: () => import('../views/Information/NoticeDetail.vue')
  },
  {
    path: '/policies-home',
    name: 'PoliciesHome',
    component: () => import('../views/Information/PoliciesHome.vue')
  },
  {
    path: '/policies-detail',
    name: 'PoliciesDetail',
    component: () => import('../views/Information/PoliciesDetail.vue')
  },
  {
    path: '/work-guide-home',
    name: 'WorkGuideHome',
    component: () => import('../views/Information/WorkGuideHome.vue')
  },
  {
    path: '/work-guide-detail',
    name: 'WorkGuideDetail',
    component: () => import('../views/Information/WorkGuideDetail.vue')
  }
]
export default router
